import { useParams, useNavigate } from "react-router-dom";
import CurveReportForm from "./CurveReportForm";
import { useData } from "../utils/DataContext";

const CurveReportFormWrapper = () => {
  const { iraiId } = useParams<{ iraiId: string }>();
  const navigate = useNavigate();
  const { iraiData } = useData();
  
  if (!iraiId) return null;
  const currentIrai = iraiData.find(item => item.id === iraiId);
  if (currentIrai && currentIrai.statusId !== 30) {
    navigate("/iraiList");
    return <></>; // 画面を表示しない
  }
  
  return (
    <CurveReportForm
      iraiId={iraiId}
      onClose={() => navigate("/iraiList")}
    />
  );
};

export default CurveReportFormWrapper;